import * as cornerstone from "cornerstone-core";
import CancelableAxiosInstance from "../api/CancelableAxiosInstance";
import GuidUtil from "./GuidUtil";
import { withClient } from "../cornerstone-core/GlmImageLoader";
import * as cornerstoneTools from "cornerstone-tools";
import * as Hammer from "hammerjs";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import * as dicomParser from "dicom-parser";
import { AUTH_HTTP_HEADER } from "../component/auth/AuthContext";

export default class CornerstoneUtil {
  private static toolsSetup = false;
  private static wadoImgLoaderSetup = false;

  static setupTools() {
    if (!CornerstoneUtil.toolsSetup) {
      cornerstoneTools.external.Hammer = Hammer;
      cornerstoneTools.external.cornerstone = cornerstone;
      cornerstoneTools.external.cornerstoneMath = cornerstoneMath;

      cornerstoneTools.init();
    }

    CornerstoneUtil.toolsSetup = true;
  }

  static configureWADOImageLoader(bearerToken: string) {
    cornerstoneWADOImageLoader.configure({
      beforeSend: function (xhr: any) {
        xhr.setRequestHeader(AUTH_HTTP_HEADER, bearerToken);
      },
    });
  }

  static setupWADOImageLoader() {
    if (!CornerstoneUtil.wadoImgLoaderSetup) {
      cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
      cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
      cornerstoneWADOImageLoader.webWorkerManager.initialize({
        maxWebWorkers: navigator.hardwareConcurrency || 2,
        startWebWorkersOnDemand: true, // Otherwise it will launch maxWebWorkers at startup
        webWorkerPath: "./cornerstoneWADOImageLoaderWebWorker.js",
        taskConfiguration: {
          decodeTask: {
            loadCodecsOnStartup: true,
            initializeCodecsOnStartup: false,
            codecsPath: "./cornerstoneWADOImageLoaderCodecs.js",
          },
        },
      });

      const MAXIMUM_CACHE_BYTES = 1024 * 1024 * 1024; // 1GB
      cornerstone.imageCache.setMaximumSizeBytes(MAXIMUM_CACHE_BYTES);
    }

    CornerstoneUtil.wadoImgLoaderSetup = true;
  }

  /**
   * Return a unique imageLoaderScheme for our own GlmImageLoader
   * You must unregister loader using this imageLoaderScheme when you don't need it anymore
   * @param client
   */
  static setupLoader(client: CancelableAxiosInstance): string {
    const imageLoaderScheme = "GLM" + GuidUtil.generate();
    cornerstone.registerImageLoader(imageLoaderScheme, withClient(client, imageLoaderScheme + "://"));
    return imageLoaderScheme;
  }

  static unregisterLoader(imageLoaderScheme: string) {
    cornerstone.registerImageLoader(imageLoaderScheme, null);
  }

  static loadAndCacheImage(imageLoaderScheme: string, imagePath: string): Promise<HTMLImageElement> {
    let uri: string;

    if (imagePath.endsWith(".dcm")) {
      // use wado image file loader
      uri = "wadouri:/api/images/" + imagePath;
    } else {
      // use glmImageLoader
      uri = imageLoaderScheme + "://" + imagePath;
    }

    return cornerstone.loadAndCacheImage(uri);
  }
}
